import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

type MediaKind = 'image' | 'video' | 'unsupported';

@Component({
	standalone: false,
	selector: 'bt-media-visualizer',
	templateUrl: './media-visualizer.component.html',
	styleUrls: ['./media-visualizer.component.scss']
})
export class MediaVisualizerComponent implements OnInit {
	readonly #route = inject(ActivatedRoute);

	src = '';
	mediaKind: MediaKind = 'unsupported';

	ngOnInit(): void {
		this.#route.queryParams.subscribe((params) => {
			this.src = params['src'] ?? '';
			this.mediaKind = this.resolveMediaKind(this.src);
		});
	}

	getExtension(src: string): string {
		if (!src) {
			return '';
		}

		const pathWithoutQuery = src.split('?')[0];
		const lastSegment = pathWithoutQuery.split('/').pop() ?? '';
		const dotIndex = lastSegment.lastIndexOf('.');

		if (dotIndex < 0) {
			return '';
		}

		return lastSegment.substring(dotIndex + 1).toLowerCase();
	}

	private resolveMediaKind(src: string): MediaKind {
		const extension = this.getExtension(src);

		if (['jpeg', 'jpg', 'png'].includes(extension)) {
			return 'image';
		}

		if (['mkv', 'mp4'].includes(extension)) {
			return 'video';
		}

		return 'unsupported';
	}
}
